// styles.js
// Styling for ForgotPassword page

import { COLORS, TYPOGRAPHY, LAYOUT, BUTTON_STYLES } from '../../constants';

export const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: COLORS.grayLight,
    padding: '40px 20px',
    position: 'relative',
    overflow: 'hidden'
  },

  backgroundDecoration: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: 0.03,
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'%3E%3Cg fill-rule='evenodd'%3E%3Cg fill='%23CE1126' fill-opacity='1'%3E%3Cpath opacity='.5' d='M96 95h4v1h-4v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9zm-1 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm9-10v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
    pointerEvents: 'none'
  },

  card: {
    maxWidth: '500px',
    width: '90%',
    backgroundColor: COLORS.white,
    borderRadius: '20px',
    padding: '48px 40px',
    boxShadow: '0 20px 60px rgba(206, 17, 38, 0.15), 0 0 0 1px rgba(206, 17, 38, 0.05)',
    border: `3px solid ${COLORS.primary}`,
    position: 'relative',
    zIndex: 1
  },

  header: {
    textAlign: 'center',
    marginBottom: LAYOUT.spacing.xxl
  },

  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: LAYOUT.spacing.lg
  },

  logoIcon: {
    width: '80px',
    height: '80px',
    borderRadius: '50%',
    background: `linear-gradient(135deg, ${COLORS.primary}, ${COLORS.primaryDark})`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 8px 24px rgba(206, 17, 38, 0.3)',
    border: '4px solid white',
    overflow: 'hidden'
  },

  logoImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },

  logoText: {
    ...TYPOGRAPHY.heading2,
    fontSize: '2rem',
    fontWeight: '900',
    color: COLORS.white,
    letterSpacing: '2px'
  },

  title: {
    ...TYPOGRAPHY.heading2,
    fontSize: '2rem',
    fontWeight: '800',
    color: COLORS.text.primary,
    marginBottom: LAYOUT.spacing.sm
  },

  subtitle: {
    ...TYPOGRAPHY.body,
    color: COLORS.text.secondary,
    fontSize: '1rem',
    lineHeight: '1.6',
    marginTop: LAYOUT.spacing.sm
  },

  form: {
    width: '100%'
  },

  inputGroup: {
    marginBottom: LAYOUT.spacing.lg
  },

  inputLabel: {
    ...TYPOGRAPHY.caption,
    display: 'block',
    marginBottom: LAYOUT.spacing.xs,
    color: COLORS.text.primary,
    fontWeight: '600',
    fontSize: '0.875rem'
  },

  inputWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center'
  },

  inputIcon: {
    position: 'absolute',
    left: '16px',
    pointerEvents: 'none',
    zIndex: 1
  },

  input: {
    width: '100%',
    padding: '14px 16px 14px 48px',
    fontSize: '1rem',
    border: `2px solid ${COLORS.border}`,
    borderRadius: LAYOUT.borderRadius.md,
    backgroundColor: COLORS.white,
    transition: 'all 0.2s ease',
    fontFamily: TYPOGRAPHY.body.fontFamily,
    outline: 'none'
  },

  inputFocused: {
    borderColor: COLORS.primary,
    boxShadow: `0 0 0 3px rgba(206, 17, 38, 0.1)`
  },

  inputError: {
    borderColor: COLORS.error,
    boxShadow: `0 0 0 3px rgba(220, 38, 38, 0.1)`
  },

  errorContainer: {
    marginBottom: LAYOUT.spacing.md,
    padding: '12px 16px',
    backgroundColor: 'rgba(220, 38, 38, 0.08)',
    border: `2px solid ${COLORS.error}`,
    borderRadius: LAYOUT.borderRadius.md
  },

  errorText: {
    ...TYPOGRAPHY.caption,
    color: COLORS.error,
    margin: 0,
    fontSize: '0.875rem',
    fontWeight: '500'
  },

  submitButton: {
    ...BUTTON_STYLES.primary,
    width: '100%',
    padding: '16px 24px',
    fontSize: '1rem',
    fontWeight: '700',
    marginTop: LAYOUT.spacing.md,
    borderRadius: LAYOUT.borderRadius.md,
    boxShadow: '0 4px 16px rgba(206, 17, 38, 0.2)',
    transition: 'all 0.3s ease',
    cursor: 'pointer'
  },

  submitButtonDisabled: {
    opacity: 0.6,
    cursor: 'not-allowed',
    transform: 'none !important'
  },

  backLinkContainer: {
    marginTop: LAYOUT.spacing.lg,
    textAlign: 'center'
  },

  backLink: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    background: 'none',
    border: 'none',
    color: COLORS.primary,
    fontSize: '0.875rem',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    textDecoration: 'none',
    padding: '8px 0'
  },

  // Success state styles
  successIconContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: LAYOUT.spacing.lg
  },

  successTitle: {
    ...TYPOGRAPHY.heading2,
    fontSize: '2rem',
    fontWeight: '800',
    color: COLORS.text.primary,
    textAlign: 'center',
    marginBottom: LAYOUT.spacing.md
  },

  successText: {
    ...TYPOGRAPHY.body,
    color: COLORS.text.secondary,
    fontSize: '1rem',
    textAlign: 'center',
    marginBottom: LAYOUT.spacing.sm
  },

  emailDisplay: {
    ...TYPOGRAPHY.body,
    fontSize: '1.1rem',
    fontWeight: '700',
    color: COLORS.primary,
    textAlign: 'center',
    padding: '16px 24px',
    backgroundColor: 'rgba(206, 17, 38, 0.05)',
    border: `2px solid rgba(206, 17, 38, 0.2)`,
    borderRadius: LAYOUT.borderRadius.md,
    marginBottom: LAYOUT.spacing.lg,
    wordBreak: 'break-word'
  },

  instructionText: {
    ...TYPOGRAPHY.body,
    color: COLORS.text.secondary,
    fontSize: '0.95rem',
    textAlign: 'center',
    lineHeight: '1.6',
    marginBottom: LAYOUT.spacing.lg
  },

  tipsContainer: {
    padding: '20px',
    backgroundColor: 'rgba(249, 208, 22, 0.08)',
    border: '2px solid rgba(249, 208, 22, 0.3)',
    borderRadius: LAYOUT.borderRadius.md,
    marginBottom: LAYOUT.spacing.xl
  },

  tipsTitle: {
    ...TYPOGRAPHY.heading3,
    fontSize: '1rem',
    fontWeight: '700',
    color: COLORS.text.primary,
    marginBottom: LAYOUT.spacing.sm
  },

  tipsList: {
    ...TYPOGRAPHY.caption,
    color: COLORS.text.secondary,
    fontSize: '0.875rem',
    lineHeight: '1.6',
    margin: 0,
    paddingLeft: '20px'
  },

  backButton: {
    ...BUTTON_STYLES.primary,
    width: '100%',
    padding: '16px 24px',
    fontSize: '1rem',
    fontWeight: '700',
    borderRadius: LAYOUT.borderRadius.md,
    boxShadow: '0 4px 16px rgba(206, 17, 38, 0.2)',
    transition: 'all 0.3s ease',
    cursor: 'pointer'
  }
};
